import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { easeOutExpo } from "@/lib/motion";

// Animated number that counts from 0 to `to` when scrolled into view.
export default function Counter({ to = 100, suffix = "", duration = 2, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration,
      ease: easeOutExpo,
      onUpdate: (v) => setValue(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to, duration]);

  return (
    <span ref={ref} className={className}>
      {value}
      {suffix}
    </span>
  );
}
